import { employeeColumns, employeesRowKey } from 'shared-feature-stats';

import { DataGridPremiumProps, GridColDef } from '@sbv-clients/ui-shared';

export const facilitiesColumns: GridColDef[] = [
  ...employeeColumns,
  {
    headerName: 'Facility Name',
    field: employeesRowKey('facilityName'),
  },
];

export const groupingColDef: DataGridPremiumProps['groupingColDef'] = {
  flex: 3,
  leafField: employeesRowKey('fullName'),
  hideDescendantCount: true,
};
